import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-datepicker-range',
  templateUrl: './datepicker-range.component.html',
  styleUrls: ['./datepicker-range.component.scss']
})
export class DatepickerRangeComponent implements OnInit {
  @Input() controlTo: AbstractControl = new FormControl();
  @Input() controlFrom: AbstractControl = new FormControl();
  @Input() label: string = "";
  @Input() idForm: string;
  @Input() placeholder: string = "DD/MM/YYYY - DD/MM/YYYY";
  @Input() bsRangeValue: Date[];

  constructor(private localeService: BsLocaleService) {
  }

  ngOnInit(): void {
    this.localeService.use('es');
  }

  onValueChange(newDate: Date) {
    if (typeof newDate === 'undefined' || typeof newDate[0] === 'undefined' || typeof newDate[1] === 'undefined') {
      this.controlTo.setValue(null);
      this.controlFrom.setValue(null);
      return
    }
    const datepipe: DatePipe = new DatePipe('en-US')
    this.controlTo.setValue(datepipe.transform(newDate[0].toISOString(), 'dd/MM/yyyy'));
    this.controlFrom.setValue(datepipe.transform(newDate[1].toISOString(), 'dd/MM/yyyy'));
  }
}
